/**
 * These events are being tracked by our custom activity-metric api
 */
import { legacyTrackEvent } from '@pok/viewer-api-sdk';

export const trackActivity = async (category, action, certificateId, organizationId) =>
    legacyTrackEvent(import.meta.env.VITE_VIEWER_API_ROOT, {
        category: category,
        action: action,
        certificate: certificateId,
        organization: organizationId,
    });

export const trackUniqueActivity = async (category, action, certificateId, organizationId) => {
    const key = category.concat(action).concat(certificateId);
    if (sessionStorage.getItem(key) === null) {
        sessionStorage.setItem(key, new Date().getTime().toString());
        return trackActivity(category, action, certificateId, organizationId);
    }
    return Promise.resolve();
};
